import React, { FC } from 'react';

import { ExportButton } from '~/components';
import { CreateBackgroundTaskParams } from '~/api/backgroundTasks';
import BackgroundTask, { useBackgroundTaskTranslate } from './BackgroundTask';
import { useCheckBackgroundTask } from '~/hooks/useBackgroundTasks';

interface Props {
  type: CreateBackgroundTaskParams['type'];
  queryArguments?: any;
}

const BackgroundTaskExport: FC<Props> = (props) => {
  const { type, queryArguments = {} } = props;
  const t = useBackgroundTaskTranslate();
  const { isLoading, data } = useCheckBackgroundTask(type);
  if (isLoading || !data?.available) return null;

  const rowsLimitCsv = data?.parameters.rowsLimitCsv;
  const rowsLimitExcel = data?.parameters.rowsLimitExcel;

  return (
    <>
      <BackgroundTask
        type={type}
        queryArguments={{
          ...queryArguments,
          exportFormat: 'CSV',
        }}
        dialogTitle={t('downloadCSV')}
        dialogType='export'
        confirmationSettings={
          rowsLimitCsv
            ? {
                confirmationTitle: t('confirmationExportTitle', {
                  maxRecordsNumber: rowsLimitCsv,
                }),
                confirmationBody: t('confirmationExportBody', {
                  maxRecordsNumber: rowsLimitCsv,
                }),
              }
            : undefined
        }
      >
        <ExportButton label='CSV' />
      </BackgroundTask>
      <BackgroundTask
        type={type}
        queryArguments={{
          ...queryArguments,
          exportFormat: 'XLSX',
        }}
        dialogTitle={t('downloadExcel')}
        dialogType='export'
        confirmationSettings={
          rowsLimitExcel
            ? {
                confirmationTitle: t('confirmationExportTitle', {
                  maxRecordsNumber: rowsLimitExcel,
                }),
                confirmationBody: t('confirmationExportBody', {
                  maxRecordsNumber: rowsLimitExcel,
                }),
              }
            : undefined
        }
      >
        <ExportButton label='Excel' />
      </BackgroundTask>
    </>
  );
};

export default BackgroundTaskExport;
